import { IToolboxComponentGroup } from "@shesha-io/reactjs";
import ButtonDropdownComponent from "./buttonDropdown";

/**
 * Custom form designer components registered for this application.
 * Add new custom components to the relevant group below.
 */
export const customComponentGroups: IToolboxComponentGroup[] = [
  {
    name: "Custom",
    visible: true,
    components: [ButtonDropdownComponent],
  },
];
